import { render, staticRenderFns } from "./BarberDataSheet.vue?vue&type=template&id=1076c4be"
import script from "./BarberDataSheet.vue?vue&type=script&lang=js"
export * from "./BarberDataSheet.vue?vue&type=script&lang=js"
import style0 from "./BarberDataSheet.vue?vue&type=style&index=0&id=1076c4be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports